import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { CommonService } from '../../common-service';
import { environment } from '../../../../../environments/environment';
import { ListaAiAgentResponse } from '../../responses/chat-ai/ai-agent.response';

@Injectable({
  providedIn: 'root',
})
export class AiAgentService extends CommonService {
  constructor(private httpClient: HttpClient) {
    super();
  }

  public getAll(): Observable<ListaAiAgentResponse> {
    return this.httpClient
      .get<ListaAiAgentResponse>(environment.urlApiChatAI + `aiagent`, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }
}
